const breakpoints = {
  mobile: 800,
  test: width => window.matchMedia(`(max-width: ${width}px)`).matches,
};

export default breakpoints;
